import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { AdminService } from "src/app/shared/services/admin/admin.service";
import { NotificationsService } from "src/app/shared/services/notifications/notifications.service";
import { createNotification } from "src/app/shared/utils/create-notification";
import { TranslateService } from "@ngx-translate/core";
import {
  invitedStudentsListLoad,
  invitedStudentsListLoadFail,
  invitedStudentsListLoadSuccess,
} from "../../actions/admin/invited-students.actions";
import {
  deleteInvitationStudentLoad,
  deleteInvitationStudentLoadSuccess,
  deleteInvitationStudentLoadFail,
} from "../../actions/admin/delete-invitation-student.action";
import {
  InvitedStudentsPerTeacher,
  PaginatedInvitedStudentsResponse,
} from "src/app/shared/interfaces/orgadmin/invited-students";

@Injectable()
export class InvitedStudentsEffect {
  getInivitedStudentsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invitedStudentsListLoad),
      switchMap((param) => {
        return this.adminService
          .getInvitedStudents(
            param.organizationId,
            param.subId,
            param.page,
            param.pageSize,
            param.ordering,
            param.search,
          )
          .pipe(
            map(
              (
                res:
                  | InvitedStudentsPerTeacher[]
                  | PaginatedInvitedStudentsResponse,
              ) =>
                invitedStudentsListLoadSuccess({
                  invitedStudents: Array.isArray(res) ? res : res.teachers,
                  paginatedStudents: Array.isArray(res) ? undefined : res,
                  page: param.page,
                  pageSize: param.pageSize,
                }),
            ),
            catchError((error: HttpErrorResponse) =>
              of(invitedStudentsListLoadFail({ error })),
            ),
          );
      }),
    ),
  );

  deleteInvitationStudent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteInvitationStudentLoad),
      switchMap((param) => {
        return this.adminService
          .deleteInvitationStudent(
            param.organizationId,
            param.subId,
            param.invitationId,
          )
          .pipe(
            tap(() => {
              this.notificationsService.showToastr(
                createNotification({
                  content: {
                    message: this.translate.instant(
                      "GLOBAL.SNACKBAR_MESSAGES.ORGADMIN_REMOVE_INVITE_STUDENT",
                    ),
                  },
                }),
              );
            }),
            map(() =>
              deleteInvitationStudentLoadSuccess({
                invitationId: param.invitationId,
              }),
            ),
            catchError((error: HttpErrorResponse) =>
              of(deleteInvitationStudentLoadFail({ error })),
            ),
          );
      }),
    ),
  );

  constructor(
    private adminService: AdminService,
    private actions$: Actions,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
  ) {}
}
